import { gql } from '@apollo/client'
import { TrackChangeFragment } from '../fragments/trackChange.fragment'

export const GetAssebmlyElementChanges = gql`
    query getAssemblyChanges($input: GetProjectElementInput!) {
        getProjectUniformatClassification(input: $input) {
            trackChanges {
                ...trackChangeFragment
            }
        }
    }
    ${TrackChangeFragment}
`
export const GetFamilyElementChanges = gql`
    query getProjectProductFamilyChanges(
        $input: GetProjectElementInput!
        $includeProductTypeInFamilyTrackChanges: Boolean
    ) {
        getProjectProductFamily(input: $input) {
            publishedBy
            publishedDate
            trackChanges(
                includeProductTypeInFamilyTrackChanges: $includeProductTypeInFamilyTrackChanges
            ) {
                ...trackChangeFragment
            }
        }
    }
    ${TrackChangeFragment}
`

export const GetProductTypeChanges = gql`
    query getProjectProductTypeChanges($input: GetProjectElementInput!) {
        getProjectNugget(input: $input) {
            trackChanges {
                ...trackChangeFragment
            }
        }
    }
    ${TrackChangeFragment}
`
